var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.uniqueKey,class:[
    'content-wrapper',
    _vm.$store.getters.isUpmindContext && 'has-hazard-tape'
  ]},[_c('impersonation-ribbon'),_vm._v(" "),_c('content-header'),_vm._v(" "),_c('div',{staticClass:"content-body",attrs:{"data-scroll-target":"body"}},[(_vm.component)?_c(_vm.component,{tag:"component"}):_c('router-view')],1),_vm._v(" "),(_vm.hasDemoData && _vm.importIsProcessing)?_c('demo-data-progress'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }